<template>
  <div class="container">
    <h2>{{ page.Title }}</h2>
    <div v-if="page.Content" v-html="page.Content"></div>
    <div class="row">
      <div class="col-md-6">
        <!-- student_education_place -->
        <DoSelect
          v-model="page.Questions[0].Value"
          :value="page.Questions[0].Value"
          :id="page.Questions[0].QID"
          :config="page.Questions[0].Config"
          :options="page.Questions[0].Options"
          @getNewData="educationPlaceSelected"
        />
      </div>
      <div class="col-md-6">
        <!-- student_education_no_place -->
        <doInput
          v-if="page.Questions[0].Value === 1"
          v-model="page.Questions[1].Value"
          :value="page.Questions[1].Value"
          :id="page.Questions[1].QID"
          :config="page.Questions[1].Config"
        />
      </div>
      <div class="col-md-6">
        <!-- education_campus -->
        <DoSelect
          v-if="
            page.Questions[7].Options.length &&
            page.Questions[0].Value !== 1 &&
            page.Questions[0].Value !== 0
          "
          v-model="page.Questions[7].Value"
          :value="page.Questions[7].Value"
          :id="page.Questions[7].QID"
          :config="page.Questions[7].Config"
          :options="page.Questions[7].Options"
        />
      </div>
      <div class="col-md-6">
        <!-- education_no_campus -->
        <doInput
          v-if="page.Questions[7].Value === -1"
          v-model="page.Questions[8].Value"
          :value="page.Questions[8].Value"
          :id="page.Questions[8].QID"
          :config="page.Questions[8].Config"
        />
      </div>
      <div class="col-md-6">
        <!-- student_education_direction -->
        <DoSelect
          v-if="
            page.Questions[2].Options.length && page.Questions[0].Value !== 1
          "
          v-model="page.Questions[2].Value"
          :value="page.Questions[2].Value"
          :id="page.Questions[2].QID"
          :config="page.Questions[2].Config"
          :options="page.Questions[2].Options"
        />
      </div>
      <div class="col-md-6">
        <!-- student_education_no_direction -->
        <doInput
          v-if="page.Questions[0].Value === 1 || page.Questions[2].Value === 1"
          v-model="page.Questions[3].Value"
          :value="page.Questions[3].Value"
          :id="page.Questions[3].QID"
          :config="page.Questions[3].Config"
        />
      </div>
      <!-- student_education_start_date -->
      <div class="col-md-6">
        <DoDate
          v-model="page.Questions[4].Value"
          :value="page.Questions[4].Value"
          :id="page.Questions[4].QID"
          :config="page.Questions[4].Config"
        />
      </div>
    </div>
    <div class="row" style="margin-top: 40px">
      <!-- student_education_end_period -->
      <div class="col-md-3">
        <DoEducationEndPeriod
          v-model="page.Questions[5].Value"
          :value="page.Questions[5].Value"
          :id="page.Questions[5].QID"
          :config="page.Questions[5].Config"
          :options="page.Questions[5].Options"
        />
      </div>
      <!-- student_education_end_year -->
      <div class="col-md-3">
        <DoEducationEndYear
          v-model="page.Questions[6].Value"
          :value="page.Questions[6].Value"
          :id="page.Questions[6].QID"
          :config="page.Questions[6].Config"
          :options="page.Questions[6].Options"
          :noTitle="false"
        />
      </div>
      <div class="col-md-12">
        <div class="invalid-mandatory" v-if="illegal" v-html="errorText"></div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    inject: {
      $validator: '$validator',
    },
    props: {
      page: {
        type: Object,
        required: true,
      },
    },
    data: function () {
      return {
        illegal: false,
        errorText: '',
      };
    },
    methods: {
      educationPlaceSelected() {
        this.$store.state.spinner = true;
        // RESET student_education_no_place, student_education_direction, student_education_no_direction, education_campus & education_no_campus
        this.page.Questions[1].Value = '';
        this.page.Questions[2].Value = '';
        this.page.Questions[3].Value = '';
        this.page.Questions[7].Value = '';
        this.page.Questions[8].Value = '';

        // Get new options
        const payload = {
          data: {
            education_place: this.page.Questions[0].Value,
            forStudents: this.$store.state.newData[0].Questions[0].Value == 3,
          },
          endpoint: '/data/GetEducationDetails',
          component: this.page.Component,
        };
        this.$store.dispatch('getSelectOptions', payload);
      },
    },
    mounted() {
      // Get new options
      this.$store.state.spinner = true;
      const payload = {
        data: {
          forStudents: true,
        },
        endpoint: '/data/GetEducationPlaces',
        component: this.page.Component,
      };
      this.$store.dispatch('getSelectOptions', payload);
    },
  };
</script>

